import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 0.7;
const DEFAULT_HEIGHT = 0.7;

const WashingMachine: C1_FurnitureDefinition = {
  id: "washingMachine",
  icon: <C1_FurnitureIcon kind="washing-machine" />,
  description: { en: "Washing machine", de: "Waschmaschine" },
  category: RoomType.Utility,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const inset = 0.02 * PX;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
      >
        <rect
          x={inset}
          y={inset}
          width={Math.max(0, width - inset * 2)}
          height={Math.max(0, height - inset * 2)}
          rx={inset}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        {showDetails && (
          <>
            <ellipse cx={width / 2} cy={height * 0.54} rx={width * 0.29} ry={height * 0.29} fill="none" stroke={finalStrokeColor} strokeWidth={finalStrokeWidth} />
            <circle cx={width * 0.79} cy={height * 0.17} r={Math.min(0.03 * PX, width * 0.05, height * 0.05)} fill={finalStrokeColor} />
          </>
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default WashingMachine;
